import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useWorkoutHttp } from '@/core/api/workouts'
import { Workout, WorkoutPayload } from '@/core/models/workout'

export type WorkoutCollection = {
    data: Array<Workout>,
    meta?: MetaPayload,
    links?: any
}

const state: WorkoutCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const workoutCollection: Module<WorkoutCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: WorkoutCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: WorkoutPayload) => {
                state.data.push(new Workout(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useWorkoutHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: WorkoutCollection): WorkoutCollection => {
            return state
        }
    }
}